import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-faq-help',
  templateUrl: './shop-faq-help.component.html',
  styleUrls: ['./shop-faq-help.component.less']
})
export class ShopFaqHelpComponent implements OnInit {
  @Input() isHandset = false;
  constructor() { }

  ngOnInit() {
  }

  showInterCom() {
    // Legacy intercom integration disabled
    // (<any>window).Intercom(
    //   "showNewMessage",
    //   "Hi there! I see you would like to chat with us."
    // );
    //  open the users email client with an email sent to hello@seededhome.com
    window.location.href = "mailto:hello@seededhome.com";
  }
}
